import ReactSwitch from "react-switch"
import "../style.css"
import { ToggleBoxProps } from "./model"

export const ToggleBox = (props: ToggleBoxProps) => {
    const onBoxToggle = (isChecked: boolean) => {
        props.onToggle(isChecked)
    }

    return (
        <div className="shrink-0">
            <ReactSwitch
                checkedIcon={false}
                uncheckedIcon={false}
                onColor={props.onColor}
                height={24}
                width={46}
                checked={props.isChecked}
                onChange={onBoxToggle}
            />
        </div>
    )
}